import { useEffect, useState } from 'react';
import { Empty, Spin, Table } from "antd";
import urls from "../../../http/endpoints/urls";
import { getRequest } from "../../../http/axiosConfig/config";
import moment from "moment";
import Swal from 'sweetalert2';

export default function OldPayments() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const [paymentTimeVimul, setPaymentTimeVimul] = useState([]);

  const columns = [
    { title: "Bill Date", dataIndex: "BILL_DATE", width: 40 },
    {
      title: "Amount",
      dataIndex: "BILL_AMOUNT",
      width: 35,
      render: (text) => `Rs ${text}`,
    },
    { title: "Bill No", dataIndex: "BILL_NO", width: 35, hidden: true },
    {
      title: "Action",
      dataIndex: "Action",
      width: 25,
      render: (text, record) => (
        <button
          style={{
            backgroundColor: "#23b0fc",
            color: "white",
            border: "none",
            padding: "5px 8px",
            width: "80%",
            borderRadius: "4px",
            margin: "5px 5px",
            cursor: "pointer",
          }}
          onClick={() => handlepayButtonClick(record)}
        >
          Pay
        </button>
      ),
    },
  ].filter((item) => !item.hidden);
  const delay = () => new Promise((res) => setTimeout(res, 2000));
  
  const handlepayButtonClick = async (record) => {
    setLoading(true);
    await delay();
    const PreviosPaymentRespone = await getRequest(urls.getPreviousPaymentStatus(record.BILL_NO));
    if (PreviosPaymentRespone.status === 0) {
      setLoading(false);
      Swal.fire('warning', PreviosPaymentRespone.message, 'warning').then(() => {
        getOldPaymentList();
      });
      return;
    }
    try {
      let isBetween = moment().isBetween(
        moment(paymentTimeVimul.st_time, "hh.mm A"),
        moment(paymentTimeVimul.end_time, "hh.mm A"),
        "minutes",
        "[]"
      );

      if (!isBetween) {
        setLoading(false);
        Swal.fire('Warning', paymentTimeVimul.msg, 'warning');
        return;
      }

      const now = new Date();
      const dd = String(now.getDate()).padStart(2, "0");
      const mm = String(now.getMonth() + 1).padStart(2, "0");
      const yyyy = now.getFullYear();
      const hh = String(now.getHours()).padStart(2, "0");
      const min = String(now.getMinutes()).padStart(2, "0");
      const sec = String(now.getSeconds()).padStart(2, "0");
      const ms = String(now.getMilliseconds()).padStart(3, "0");

      const timestamp = `${dd}${mm}${yyyy}${hh}${min}${sec}${ms}`;

      const customerCode = localStorage.getItem("userId");
      const usersCode = localStorage.getItem("agentCode");

      const payment_details = {
        customer_code: customerCode,
        users_code: usersCode,
        route_code: record.ROUTE_CODE,
        order_id: `Ord-${customerCode}-${usersCode}-${timestamp}`,
        amount: record.BILL_AMOUNT,
        bill_no: record.BILL_NO,
        gp_date: record.BILL_DATE,
        pay_type: "R",
        type: "payment_gateway",
      };

      console.log(payment_details);
      setLoading(false);
      window.ReactNativeWebView.postMessage(JSON.stringify(payment_details));
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getPaymentTime = async () => {
    try {
      const PaymentTime = await getRequest(urls.getPayment_time_check());
      setPaymentTimeVimul(PaymentTime?.items[0]);
    } catch (error) {
      console.log(error);
    }
  };

  const getOldPaymentList = async () => {
    setLoading(true);
    try {
      const res = await getRequest(
        urls.getOldBalance(localStorage.getItem("userId"))
      );

      const rowsWithId = res.map((item, index) => ({
        id: index + 1,
        ...item,
      }));
      setRows(rowsWithId);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getOldPaymentList();
    getPaymentTime();
  }, []);

  return (
    <Spin spinning={loading} tip="Loading payments…" size="large">
      <div>
        <div className="page-header">Payments not done list</div>
      </div>
      <Table
        dataSource={rows}
        locale={{ emptyText: <Empty /> }}
        rowKey="id"
        columns={columns}
        scroll={{ y: "calc(100vh - 350px)", x: 100 }}
        pagination={false}
        style={{ border: "1px solid black", borderRight: "2px solid black" }}
      />
    </Spin>
  );
}




